import Promise from 'bluebird'
import CreateReducer from '../utils/createReducer'
import CreateActions from '../utils/createActions'

import WebsocketConnection from './websocket_connection'
import snackbarActions from './snackbar'
import poolActions from './pool'

const prefix = 'messagebus'

const initialState = {
  
}

const reducers = {

}

let webSocket = null
let connection = null
let hasSeenError = false

// channel onto handler function
let subscriptions = {}

const sideEffects = {

  // NOTE: if we want to use JWT from the browser we un-comment
  // the code here
  connect: (token) => async (dispatch, getState) => {
   
    if(!token) {
      dispatch(snackbarActions.setError(`no token given to websocket connection`))
      return
    }

    if (webSocket) {
      webSocket.onerror = webSocket.onopen = webSocket.onclose = null
      webSocket.close()
    }

    const protocol = location.protocol == 'https:' ? 'wss' : 'ws'
    webSocket = new WebSocket(`${protocol}://${location.host}/api/v1/websocket/connect?access_token=${token.token}`);
    webSocket.onerror = (e) => {
      if(hasSeenError) return
      hasSeenError = true
      dispatch(snackbarActions.setError(`error connecting to websocket`))
    }
    webSocket.onopen = () => {
      console.log('websocket connected')      
      connection = WebsocketConnection({
        dispatch,
        webSocket,
        subscriptions,
        onError: (error) => {
          console.error(`websocket message error`)
          console.error(body)
          dispatch(snackbarActions.setError(body))
        },
        onMessage: ({
          channel,
          messageType,
          body,
        }) => {
          const handler = subscriptions[channel]
          if(handler) handler({
            channel,
            messageType,
            body,
          })
        }
      })
      Object.keys(subscriptions).forEach(subscriptionChannel => {
        connection.subscribe(subscriptionChannel)
      })
    }
    webSocket.onclose = async (e) => {
      if(hasSeenError) return
      await Promise.delay(1000)
      dispatch(actions.connect(token))
    }
    
  },

  write: ({
    channel,
    messageType,
    body,
  }) => async (dispatch, getState) => {
    if(connection) {
      connection.sendMessage('pubsubMessage', {
        channel,
        messageType,
        body,
      })
    }
  },

  subscribe: (channel, handler) => async (dispatch, getState) => {
    subscriptions[channel] = handler
    if(connection) {
      connection.subscribe(channel)
    }
  },

  unsubscribe: (channel) => async (dispatch, getState) => {
    delete(subscriptions[channel])
    if(connection) {
      connection.unsubscribe(channel)
    }
  },

  // subscribe to pool updates for the team
  subscribeTeam: (user) => async (dispatch, getState) => {
    if(!user) {
      dispatch(snackbarActions.setError(`no user given to websocket connection`))
      return
    }

    if(!user.teams || user.teams.length <= 0) {
      dispatch(snackbarActions.setError(`no teams given to websocket connection`))
      return
    }

    await dispatch(actions.subscribe(`team.${user.teams[0].id}`, () => {
      dispatch(poolActions.loadSilently())
    }))
  },

  subscribeToPool: (pool, handler) => async (dispatch, getState) => {
    await dispatch(actions.subscribe(`pool.${pool.id}`, handler))
  },

  unsubscribeToPool: (pool) => async (dispatch, getState) => {
    await dispatch(actions.unsubscribe(`pool.${pool.id}`))
  },

  subscribeToLease: (lease, handler) => async (dispatch, getState) => {
    await dispatch(actions.subscribe(`lease.${lease.pool}.${lease.id}`, handler))
  },

  unsubscribeToLease: (lease) => async (dispatch, getState) => {
    await dispatch(actions.unsubscribe(`lease.${lease.pool}.${lease.id}`))
  },

  subscribeToPoolLogs: (pool, handler) => async (dispatch, getState) => {
    await dispatch(actions.subscribe(`pool_logs.${pool.id}`, handler))
  },

  unsubscribeToPoolLogs: (pool) => async (dispatch, getState) => {
    await dispatch(actions.unsubscribe(`pool_logs.${pool.id}`))
  },

  subscribeToVmLogs: (poolId, vmId, handler) => async (dispatch, getState) => {
    await dispatch(actions.subscribe(`vm_logs.${poolId}.${vmId}`, handler))
  },

  unsubscribeToVmLogs: (poolId, vmId) => async (dispatch, getState) => {
    await dispatch(actions.unsubscribe(`vm_logs.${poolId}.${vmId}`))
  },

}

const reducer = CreateReducer({
  initialState,
  reducers,
  prefix,
})

const actions = CreateActions({
  reducers,
  sideEffects,
  prefix,
})

export { actions, reducer }
export default actions